export const faqData = [
  {
    id: 1,
    question: " What is a Car Loan Balance Transfer EMI Calculator?",
    answer:
      "It’s a tool that helps you calculate your new EMI and savings when transferring your car loan to another lender offering better terms.",
  },
  {
    id: 2,
    question: " When Should I Transfer My Car Loan?",
    answerList: [
      {
        info: " If you’re paying a high-interest rate.",
      },
      {
        info: "If you’re in the early or mid-tenure of your loan.",
      },
      {
        info: "If market interest rates have dropped.",
      },
    ],
  },
  {
    id: 3,
    question: "What Costs Should I Consider Before Transferring?",
    answerList: [
      {
        info: "Processing fees charged by the new lender.",
      },
      {
        info: " Prepayment penalties from your existing lender.",
      },
      {
        info: " Other administrative charges.",
      },
    ],
  },
  {
    id: 4,
    question: " How Much Can I Save with a Balance Transfer?",
    answer:
      "Savings depend on your outstanding loan amount, current and new interest rates, and tenure. Use MinEMI’s calculator for an instant estimate.",
  },
  {
    id: 5,
    question: " Can I Extend My Loan Tenure During a Transfer?",
    answer:
      "Yes, many lenders allow you to adjust your tenure to make EMIs more affordable.",
  },
  {
    id: 6,
    question: " Are There Hidden Charges in a Balance Transfer?",
    answer:
      "MinEMI ensures transparency by displaying all fees upfront, so you can make informed decisions.",
  },
  {
    id: 7,
    question: "Can I Consolidate Multiple Car Loans with a Balance Transfer?",
    answer:
      "Yes, you can consolidate multiple loans into a single manageable repayment plan.",
  },
];

export const helpData = [
  {
    id: 1,
    needhelp: "Need help with this information? Click here",
    title: "Where to find information for the calculator",
    information: [
      {
        id: 1,

        subtitle: "Existing debt: Credit card debt to transfer",
        infotext:
          "You can check your credit card statement for details about the amount you owe. Alternatively, you can log in to your bank or credit card issuer's app or website to view the current outstanding balance. Ensure you use the total outstanding balance instead of the minimum due amount to get accurate results for your balance transfer.",
      },
      {
        id: 2,
        subtitle: "Existing debt: Interest rate",
        infotext:
          "The interest rate applicable on your credit card debt is often referred to as the Annual Percentage Rate (APR) or monthly interest rate in India. This rate can be found in your credit card statement under sections like 'Interest Charges', 'Finance Charges', or the terms and conditions shared with your credit card account. Use the APR to input an accurate value for interest in the calculator.",
      },
      {
        id: 3,
        subtitle: "Balance Transfer Loan: Processing Fee",
        infotext:
          "Most balance transfer loans or credit card balance transfers in India involve a processing fee. This fee is a one-time charge and varies depending on the lender or card issuer. You can find this information in the loan or credit card terms and conditions or by checking the lender’s website. Ensure this fee is factored into the calculation for accurate results.",
      },
      {
        id: 4,
        subtitle: "Balance Transfer Loan: New Interest Rate",
        infotext:
          "The new interest rate for a balance transfer will depend on the offer provided by your new lender or card issuer. This rate is usually lower than the existing interest rate on your current credit card. Check the lender’s website or promotional offers for this rate, often labeled as 'Balance Transfer Interest Rate' or 'Special Rate for Transfers'.",
      },
      {
        id: 4,
        subtitle: "Loan Tenure or Repayment Period",
        infotext:
          "The repayment period is the time you need to repay the transferred balance. This is typically specified by the lender and can vary between 6 to 84 months for personal loans and other credit products in India. For credit card balance transfers, shorter tenures like 3 to 12 months are common.",
      },
    ],
  },
];
